import type { Locale } from "../../types/content";

const flagByLocale: Record<Locale, string> = {
  en: "gb",
  ro: "ro",
  he: "il"
};

export function CountryFlag({ locale }: { locale: Locale }) {
  return (
    <img
      src={`/flags/${flagByLocale[locale]}.svg`}
      alt=""
      width={20}
      height={14}
      className="h-[14px] w-[20px] shrink-0 rounded-[3px] object-cover shadow-[0_0_0_1px_rgba(17,24,32,0.08)]"
    />
  );
}
